import React from 'react';

const FormInput = ({
    label,
    type = 'text',
    name,
    value,
    onChange,
    placeholder,
    required = false,
    className = '',
    min,
    readOnly = false,
    ...props
}) => {
    return (
        <div className={`col-12 ${className}`}>
            {label && (
                <label className="form-label text-secondary-light text-sm fw-medium mb-1">
                    {label} {required && <span className="text-danger">*</span>}
                </label>
            )}
            <input
                type={type}
                className="form-control radius-8 h-48-px"
                name={name}
                value={value}
                onChange={onChange}
                placeholder={placeholder}
                required={required}
                min={min}
                readOnly={readOnly}
                {...props}
            />
        </div>
    );
};

export default FormInput;
